import * as React from "react";

import { staticMediaUrl } from "../../Common";

import {
  ReactCheckout2022Route,
  useReactCheckout2022Router,
  useReactMyBagInitialState,
} from "../providers";

import { HeaderJourney } from "./header-journey";
import { HeaderBackButton } from "./header-back-button";
import { HeaderPortal } from "./header-portal";

export const Header: React.FunctionComponent = () => {
  const { initialState } = useReactMyBagInitialState();

  const { currentRoute } = useReactCheckout2022Router();

  const logoImgSrc = React.useMemo(() => {
    return staticMediaUrl(initialState, "images/logo.svg");
  }, [initialState]);

  const title = React.useMemo(() => {
    if (currentRoute === ReactCheckout2022Route.mybag) {
      return "My Bag";
    }
    return "Checkout";
  }, [currentRoute]);

  return (
    <HeaderPortal>
      <header>
        <HeaderBackButton />

        <a className="logo" href="/">
          <img src={logoImgSrc} alt="Bed Bath N' Table" />
        </a>

        <div className="empty-right-side-of-the-logo"></div>

        <h1>{`${title}`}</h1>

        <HeaderJourney />
      </header>
    </HeaderPortal>
  );
};
